import { IIdsRequest } from "../../../models/request/base/IIdsRequest";
import { IChieuCaoCanNangSelectByLopRequest } from "../../../models/request/dan-thuoc/IChieuCaoCanNangSelectByLopRequest";
import { IHocSinhSelectRequest } from "../../../models/request/hoc-sinh/IHocSinhSelectRequest";
import { IHocSinhSelectResponeItem } from "../../../models/response/hoc-sinh/IHocSinhSelectRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from '../IGenericActionType';
import { IChieuCaoCanNang } from './../../../models/response/dan-thuoc/IChieuCaoCanNang';

export const eChieuCaoCanNangDefine = {
    LOAD_HOC_SINH_START: {} as IHocSinhSelectRequest,
    LOAD_HOC_SINH_SUCCESS: [] as IHocSinhSelectResponeItem[],
    LOAD_HOC_SINH_ERROR: "",

    LOAD_KETQUA_START: {} as IChieuCaoCanNangSelectByLopRequest,
    LOAD_KETQUA_SUCCESS: [] as IChieuCaoCanNang[],
    LOAD_KETQUA_ERROR: "",

    SAVE_START: {} as IChieuCaoCanNang,
    SAVE_SUCCESS: {} as IChieuCaoCanNang,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: {} as IChieuCaoCanNang,
    DELETE_ERROR: "",

    CHANGE_FILTER: {} as IChieuCaoCanNangSelectByLopRequest,
    CHANGE_HOCSINH_SELECTED: 0,

    SEND_NOTIFY_START: {} as IIdsRequest,
    SEND_NOTIFY_SUCCESS: [] as IChieuCaoCanNang[],
    SEND_NOTIFY_ERROR: "",
}
export const eChieuCaoCanNangActionTypeIds = generateActionTypeIds(eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG")
export type IChieuCaoCanNangActionTypes = IGenericActionType<typeof eChieuCaoCanNangDefine, "CHEU_CAO_CAN_NANG">